export enum Colour {
  turquoise = 'turquoise',
  lightTurquoise = 'turquoise-light',
  mint = 'mint',
  green = 'green',
  purple = 'purple',
  pink = 'pink',
  blue = 'blue',
  steelBlue = 'steel-blue',
  yellow = 'yellow',
  red = 'red',
  orange = 'orange',
  lightPink = 'pink-light',
  grey = 'grey',
  black = 'black',
  white = 'white',
  lightBlue = 'blue-light',
  lightPurple = 'purple-light',
  lightRed = 'red-light',
  tomato = 'tomato',
  coral = 'coral',
  lightTomato = 'tomato-section',
  mint2 = 'mint-v2',
  rose = 'rose',
  glory = 'morning-glory',
  golden = 'golden-tainoi',
  bird = 'humming-bird',
  celadon = 'celadon',
  almond = 'almond',
  cinderella = 'cinderella',
  paleTurquoise = 'pale-turquoise',
  shalimar = 'shalimar',
  frenchPass = 'french-pass',
}
